import Layout from '@/layout';
var productRouter = {
  path: '/supply',
  component: Layout,
  redirect: '/supply/list',
  name: 'SupplierProduct',
  meta: {
    title: '供货管理',
    icon: 'el-icon-goods'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/supplier/supply/index');
    },
    name: 'SupplierProductList',
    meta: {
      title: '供货列表'
    }
  }, {
    path: 'add',
    component: function component() {
      return import('@/views/supplier/supply/add');
    },
    name: 'SupplierProductAdd',
    meta: {
      title: '新增供货',
      activeMenu: '/supply/list'
    },
    hidden: true
  }, {
    path: 'edit/:id',
    component: function component() {
      return import('@/views/supplier/supply/add');
    },
    name: 'SupplierProductEdit',
    meta: {
      title: '编辑供货',
      activeMenu: '/supply/list'
    },
    hidden: true
  }, {
    path: 'detail/:id',
    component: function component() {
      return import('@/views/supplier/supply/add');
    },
    name: 'SupplierProductDetail',
    meta: {
      title: '供货详情',
      activeMenu: '/supply/list'
    },
    hidden: true
  }, {
    path: 'specs',
    component: function component() {
      return import('@/views/supplier/supply/specs');
    },
    name: 'SupplierProductSpecs',
    meta: {
      title: '供货规格'
    },
    hidden: true
  }, {
    path: 'comments',
    component: function component() {
      return import('@/views/supplier/supply/comments');
    },
    name: 'SupplierProductComments',
    meta: {
      title: '供货评论'
    },
    hidden: true
  }]
};
export default productRouter;